import { render, staticRenderFns } from "./EstimatePreviewTable.vue?vue&type=template&id=00871c5e&"
import script from "./EstimatePreviewTable.vue?vue&type=script&lang=js&"
export * from "./EstimatePreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports